// extracted by mini-css-extract-plugin
export default {"container":"history_container__ebZuk","infoSection":"history_infoSection__qdKRW","timeline":"history_timeline__84Enf"};